import { useQuery } from '@tanstack/react-query'
import {
  getHighnoteErrorCodes,
  HighnoteErrorCode,
} from 'api/admin/highnote/getErrorCodes'
import { highnoteKeys } from './keys'

export interface HighnoteErrorCodeRegistry {
  items: HighnoteErrorCode[]
  byCode: Record<number, HighnoteErrorCode>
}

/**
 * Highnote error code registry. This is a static mapping that rarely changes,
 * so it's cached indefinitely for the session.
 */
export const useHighnoteErrorCodes = () =>
  useQuery({
    queryKey: highnoteKeys.errorCodes(),
    queryFn: getHighnoteErrorCodes,
    staleTime: Infinity,
    select: (items): HighnoteErrorCodeRegistry => {
      const byCode: Record<number, HighnoteErrorCode> = {}
      for (const item of items) {
        byCode[item.code] = item
      }
      return { items, byCode }
    },
  })
